import { useQuery } from "@tanstack/react-query";
import type { UiTemplateSection } from "@/domains/templates/types";
import {
  getStepVariableSources,
  getStepVariableBindingReadiness,
} from "@/domains/templates/step-variable-bindings";
import { templateBuilderQueries } from "@/features/template-builder/queries";
import { Badge } from "@/shared/components/ui/badge";
export function TemplateStepBindingStatus({
  templateId,
  section,
}: {
  templateId: string;
  section: UiTemplateSection;
}) {
  const steps = useQuery(templateBuilderQueries.steps(templateId));
  if (!steps.data) return null;
  const incomplete = section.variables.some((variable) => {
    if (
      variable.binding_kind !== "step_variable" &&
      variable.binding_kind !== "step_output"
    )
      return false;
    const type =
      variable.binding_kind === "step_output"
        ? "array"
        : variable.variable_type;
    const groups = getStepVariableSources(
      steps.data,
      section.id,
      variable.binding_kind === "step_output"
        ? (variable.binding_source_step_id ?? "__none__")
        : undefined,
      type,
    );
    const source = groups
      .flatMap((group) => [...group.inputs, ...group.outputs])
      .find((source) => source.id === variable.binding_source_variable_id);
    return (
      !source ||
      getStepVariableBindingReadiness(source, variable.binding_path, type) ===
        "incomplete"
    );
  });
  return incomplete ? <Badge variant="outline">Incomplete</Badge> : null;
}
